/*
 * @Author: cc
 * @Date: 2021-01-13 19:23:07
 * @LastEditTime: 2021-01-20 11:58:04
 * @LastEditors: cc
 * @FilePath: \MCN_new\app\main\submissionManage\personalLibrary\editVideo\editVideo_router.js
 * @Description: 
 */
/**
 * pgc视频路由
 */
'use strict';
angular.module('editVideoRouterModule', []).config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('editvideo', {
            url: '/editvideo?id&type',
            views: {
                '': {
                    template: '<div class="view_head" ui-view="header"></div>' + '<div class="view_body">' + '<div class="" ui-view="main"></div>' + '</div>'
                },
                'header@editvideo': {
                    templateUrl: 'header/headerDetails_tpl.html',
                    controller: 'webHeaderCtrl'
                },
                'main@editvideo': {
                    templateUrl: './main/submissionManage/personalLibrary/editVideo/editVideo.html',
                    controller: 'editVideoCtrl'
                }
            }
        });
    }
]);
